module.exports = __webpack_public_path__ + "static/img/sustainability_company.b7e1547.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company/sustainability_company.png
// module id = 9vsb
// module chunks = 0